import React from "react";
import styles from "./styles.module.css";
import logo from "../../images/logoBrancoPrincipal.png";

import { useNavigate } from "react-router-dom";
import { Box, Grid, Typography } from "@mui/material";
import { GridLoader } from "react-spinners";
import { Link } from "@mui/material";

const NotFound = () => {
    const navigate = useNavigate();

    const navigateBack = () => {
        navigate("/dashboard");
    }

    return (
        <Box className={styles.container}>
            <Box className={styles.background}
            >
                <Grid
                    container
                    spacing={0}
                    direction="column"
                    zIndex="0"
                    position="relative"
                    alignItems="center"
                    justifyContent="center"
                >
                    <Grid item xs={3}>
                        <GridLoader
                            color="#FFFFFF"
                            loading={true}
                            size={25}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                        >
                        </GridLoader>
                    </Grid>
                    <Typography className={styles.titulo404}>
                        404
                    </Typography>
                    <Typography className={styles.titulo}
                    >
                        Página Não Encontrada
                    </Typography>
                    <Link
                        component="button"
                        onClick={navigateBack}
                        sx={{
                            marginTop: "2rem"
                        }}>
                        <img src={logo} className={styles.logoMenu} alt="Logo"></img>
                    </Link>
                </Grid>
            </Box>
        </Box>
    );
};

export default NotFound;
